import React from "react";
import { motion } from "framer-motion";

export default function ChartLoader({ title = "Loading Chart", subtitle = "Fetching latest data..." }) {
  return (
    <div className="absolute inset-0 z-10 flex flex-col h-full items-center justify-center rounded-2xl bg-[#060C18]/60 backdrop-blur-sm" data-testid="chart-loader">
      <motion.div
        className="relative flex items-center justify-center"
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
      >
        <div className="w-10 h-10 rounded-full border-2 border-cyan-400/30 border-t-cyan-400" />
      </motion.div>

      <motion.div
        className="mt-3 w-2 h-2 rounded-full bg-cyan-400"
        animate={{ scale: [1, 1.5, 1], opacity: [0.6, 1, 0.6] }}
        transition={{ duration: 1.4, repeat: Infinity }}
      />

      <p className="mt-3 text-xs font-semibold tracking-[0.15em] uppercase text-cyan-200">{title}</p>
      <p className="text-[11px] text-slate-400 mt-1">{subtitle}</p>
    </div>
  );
}
